import React from 'react';
import { Box, Typography, Grid, Paper } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import seagullexterior1 from '../images/seagull-sg-1.jpg';
import seagullexterior2 from '../images/seagull-sg-2.jpg';
import seagullexterior3 from '../images/seagull-sg-3.jpg';
import seagullexterior4 from '../images/seagull-sg-4.jpg';
import seagullexterior5 from '../images/seagull-sg-5.png';
import seagullexterior6 from '../images/seagull-sg-6.png';

function ExteriorSeagull() {
  return (
    <Box
      sx={{ padding: { xs: 2, sm: 4 }, maxWidth: '1200px', margin: '0 auto' }}
    >
      <Helmet>
        <title>Eksterior BYD Atto 1 NIK 2026 | Dimensi, Velg & Warna</title>
        <meta
          name='description'
          content='Lihat eksterior BYD Atto 1 NIK 2026: dimensi 3.925 x 1.720 x 1.550 mm, velg 16 inci, radius putar 4,95 meter, dan pilihan warna di BYD BSD Serpong.'
        />
        <meta
          name='keywords'
          content='eksterior BYD Atto 1, dimensi BYD Atto 1, radius putar BYD Atto 1, warna BYD Atto 1 NIK 2026, BYD BSD Serpong'
        />
        <link
          rel='canonical'
          href='https://bydbsdserpong.com/blog/eksterior-byd-atto1'
        />
      </Helmet>
      <br />
      <br />
      <br />
      <br />
      <Typography variant='h3' component='h1' fontWeight='bold' gutterBottom>
        Eksterior BYD Atto 1 NIK 2026: Kompak untuk Mobilitas Kota
      </Typography>

      <Typography
        variant='body1'
        paragraph
        sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}
      >
        <strong>BYD Atto 1 NIK 2026</strong> memiliki dimensi kompak untuk
        penggunaan di area perkotaan. Artikel ini membahas ukuran bodi, radius
        putar, velg, detail depan, profil samping, bagian belakang, dan pilihan
        warna yang ditampilkan untuk unit terbaru.
      </Typography>

      <Grid container spacing={4} sx={{ my: 4 }}>
        {[
          {
            img: seagullexterior1,
            caption: 'Tampilan depan Atto 1: tajam, tegas, dan kompak.',
          },
          {
            img: seagullexterior2,
            caption: 'Tampilan frontal penuh dengan aura sporty & urban.',
          },
          {
            img: seagullexterior3,
            caption:
              'Bagian belakang menonjolkan karakter modern, lengkap dengan spoiler.',
          },
          {
            img: seagullexterior4,
            caption: 'Detail velg 16 inci dengan ban 185/55 R16.',
          },
          {
            img: seagullexterior5,
            caption: 'Siluet samping yang aerodinamis dan ergonomis.',
          },
          {
            img: seagullexterior6,
            caption: 'Tampilan belakang dengan lampu LED tipis memanjang.',
          },
        ].map((item, idx) => (
          <Grid item xs={12} sm={6} key={idx}>
            <Paper sx={{ p: 2, borderRadius: 2 }}>
              <Box
                component='img'
                src={item.img}
                alt={item.caption}
                sx={{ width: '100%', borderRadius: 2, mb: 1 }}
              />
              <Typography variant='body2' color='textSecondary'>
                {item.caption}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>

      <Box sx={{ mt: 4 }}>
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          🚗 Desain Aerodinamis & Kompak untuk Kota Modern
        </Typography>
        <Typography paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.9 }}>
          Eksterior Atto 1 menampilkan dimensi yang cocok untuk kebutuhan urban.
          Dengan panjang 3.925 mm dan lebar 1.720 mm, mobil ini mudah
          ditempatkan di area parkir dan tetap lincah di jalan kota. Desainnya
          menonjolkan garis-garis tajam, headlamp LED sipit, serta gril
          minimalis yang memberikan kesan futuristik ala mobil masa depan.
          Bagian bawah bumper dirancang dengan aksen sport yang tegas.
        </Typography>

        <Typography paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.9 }}>
          Tidak hanya itu, bagian samping dilengkapi fender tebal yang
          memperkuat kesan tangguh. Velg 16 inci berwarna gelap memberikan
          kontras menarik dengan warna bodi cerah. Rear spoiler di bagian atas
          belakang membuatnya tampak lebih sporty, sedangkan lampu belakang LED
          berbentuk garis horizontal menciptakan identitas visual yang khas dari
          BYD.
        </Typography>
      </Box>

      <Box sx={{ mt: 6 }}>
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          🌈 Pilihan Warna Cerah & Berani
        </Typography>
        <Typography paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.9 }}>
          Pilihan warna yang ditampilkan untuk Atto 1 NIK 2026 adalah Cosmos
          Black, Apricity White, dan Sprout Green. Ketersediaan warna dapat
          berubah mengikuti stok unit, jadi konfirmasi warna sebelum pemesanan.
        </Typography>
      </Box>

      <Box sx={{ mt: 6 }}>
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          Spesifikasi Dimensi Eksterior BYD Atto 1
        </Typography>
        <ul style={{ fontSize: '1.1rem', lineHeight: 2 }}>
          <li>Panjang: 3.925 mm</li>
          <li>Lebar: 1.720 mm</li>
          <li>Tinggi: 1.550 mm</li>
          <li>Jarak sumbu roda: 2.500 mm</li>
          <li>Radius putar minimum: 4,95 meter</li>
          <li>Velg dan ban: 16 inci, 185/55 R16</li>
        </ul>
      </Box>

      <Box sx={{ mt: 6 }}>
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          Harga BYD Atto 1 NIK 2026
        </Typography>
        <Typography paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.9 }}>
          Harga indikatif BYD Atto 1 NIK 2026 mulai sekitar{' '}
          <strong>Rp210 juta untuk Dynamic</strong> dan{' '}
          <strong>Rp245 juta untuk Premium</strong>. Harga OTR, promo, dan stok
          unit dapat berubah sehingga perlu dikonfirmasi sebelum pemesanan.
        </Typography>
        <Typography paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.9 }}>
          Dynamic cocok untuk kebutuhan city car listrik yang efisien, sedangkan
          Premium menawarkan jarak tempuh lebih panjang dan kamera 360.
        </Typography>
      </Box>

      <Paper
        sx={{
          p: 4,
          mt: 8,
          backgroundColor: '#fffde7',
          borderLeft: '6px solid #fdd835',
          borderRadius: 2,
        }}
      >
        <Typography variant='h5' fontWeight='bold' gutterBottom>
          Tertarik dengan BYD Atto 1? Kunjungi Dealer BYD BSD Serpong Sekarang!
        </Typography>
        <Typography variant='body1' gutterBottom>
          Ingin melihat langsung dan test drive BYD Atto 1? Dealer resmi kami di{' '}
          <strong>BYD BSD Serpong</strong> siap melayani kamu. Kami juga
          menyediakan unit <strong>Danza D9</strong> dan{' '}
          <strong>Sealion 7</strong> untuk kamu yang mencari opsi lebih premium.
        </Typography>
        <Typography variant='body2' sx={{ mt: 1 }}>
          📞{' '}
          <a
            href='https://api.whatsapp.com/send?phone=6281286864825'
            target='_blank'
            rel='noopener noreferrer'
          >
            Hubungi via WhatsApp
          </a>{' '}
          atau kunjungi{' '}
          <a
            href='https://instagram.com/bydbsdserpong'
            target='_blank'
            rel='noopener noreferrer'
          >
            @bydbsdserpong
          </a>{' '}
          untuk info lengkap dan promo terbaru!
        </Typography>
      </Paper>
    </Box>
  );
}

export default ExteriorSeagull;
